// extracted by mini-css-extract-plugin
module.exports = {"text":"input_text__TYnDk","textarea":"input_textarea__goaFb","label":"input_label__hVm_Y","input":"input_input__tb1hN"};